import { render, staticRenderFns } from "./TreatmentPlanObjectivesV1.vue?vue&type=template&id=7e5c7597&"
import script from "./TreatmentPlanObjectivesV1.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanObjectivesV1.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanObjectivesV1.vue?vue&type=style&index=0&id=7e5c7597&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports